import * as Yup from 'yup'
import { Form, InputGroup, Row, Col } from 'react-bootstrap'

type Values = {
  priority: string
  startColumn: number | string
  startRow: number | string
  length: number | string
}

type EnumValues = {
  priorities: Record<string, string>
}

type Props = {
  values: Values
  errors: Partial<Record<keyof Values, string>>
  touched: Partial<Record<keyof Values, boolean>>
  handleBlur: React.FocusEventHandler<HTMLElement>
  handleSubmit: (values: Values) => void
  setFieldValue: (field: string, value: unknown) => void
  isSettingWritable: boolean
  enumValues: EnumValues
  rowIndex: number
}

const _AuxiliaryLineSettingForm = ({
  values,
  errors,
  touched,
  handleBlur,
  handleSubmit,
  setFieldValue,
  isSettingWritable,
  enumValues,
  rowIndex
}: Props) => {
  return (
    <Row sm='auto' className={`row-${rowIndex + 1}`}>
      <Col sm={1}>{enumValues.priorities[values.priority]}記事</Col>
      <Form.Group as={Col} sm='auto'>
        <InputGroup size='sm' hasValidation>
          <Form.Control
            type='number'
            name='startColumn'
            value={
              values.startColumn !== undefined && values.startColumn !== ''
                ? parseInt(String(values.startColumn)) + 1
                : ''
            }
            onChange={(e) => {
              const startColumn = e.target.value !== '' ? parseInt(e.target.value) - 1 : ''
              setFieldValue('startColumn', startColumn)
              const newValues = { ...values, startColumn }
              if (AuxiliaryLineSettingForm.schema.isValidSync(newValues)) {
                handleSubmit(newValues)
              }
            }}
            disabled={!isSettingWritable}
            onBlur={handleBlur}
            isInvalid={!!(touched.startColumn && errors.startColumn)}
          />
          <InputGroup.Text>段目</InputGroup.Text>
          <Form.Control.Feedback type='invalid'>{errors.startColumn}</Form.Control.Feedback>
        </InputGroup>
      </Form.Group>
      <Form.Group as={Col} sm='auto'>
        <InputGroup size='sm' hasValidation>
          <Form.Control
            type='number'
            name='startRow'
            value={values.startRow !== undefined && values.startRow !== '' ? parseInt(String(values.startRow)) + 1 : ''}
            onChange={(e) => {
              const startRow = e.target.value !== '' ? parseInt(e.target.value) - 1 : ''
              setFieldValue('startRow', startRow)
              const newValues = { ...values, startRow }
              if (AuxiliaryLineSettingForm.schema.isValidSync(newValues)) {
                handleSubmit(newValues)
              }
            }}
            disabled={!isSettingWritable}
            onBlur={handleBlur}
            isInvalid={!!(touched.startRow && errors.startRow)}
          />
          <InputGroup.Text>行目</InputGroup.Text>
          <Form.Control.Feedback type='invalid'>{errors.startRow}</Form.Control.Feedback>
        </InputGroup>
      </Form.Group>
      <Form.Group as={Col} sm='auto'>
        <InputGroup size='sm' hasValidation>
          <Form.Control
            type='number'
            name='length'
            value={values.length || ''}
            onChange={(e) => {
              const length = parseInt(e.target.value)
              setFieldValue('length', length)
              const newValues = { ...values, length }
              if (AuxiliaryLineSettingForm.schema.isValidSync(newValues)) {
                handleSubmit(newValues)
              }
            }}
            disabled={!isSettingWritable}
            onBlur={handleBlur}
            isInvalid={!!(touched.length && errors.length)}
          />
          <InputGroup.Text>段</InputGroup.Text>
          <Form.Control.Feedback type='invalid'>{errors?.length}</Form.Control.Feedback>
        </InputGroup>
      </Form.Group>
    </Row>
  )
}

const startPosErrorMessage = '1以上にしてください'
export const AuxiliaryLineSettingForm = Object.assign(_AuxiliaryLineSettingForm, {
  schema: Yup.object().shape({
    priority: Yup.string().required(),
    startColumn: Yup.number().required().min(0, startPosErrorMessage),
    startRow: Yup.number().required().min(0, startPosErrorMessage),
    length: Yup.number().required().min(1)
  })
})
